// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9805124f","396":"86296b8f","455":"9b210eb6","977":"9a7c102b"}[chunkId] + ".chunk.js";
};